import minimatch from 'minimatch'

window.Minimatch = minimatch

export default function(o, done){

  var views = [
    {
      view: 'splash',
      route: '/',
    },
    {
      view: 'antiArchive',
      route: '/anti-archive',
    },
    {
      view: 'antiArchiveTag',
      route: '/anti-archive/*',
    },
    {
      view: 'stories',
      route: '/stories',
    },
    {
      view: 'story',
      route: '/stories/*',
    },
    {
      view: 'archive',
      route: '/archive',
    },
    {
      view: 'archive',
      route: '/archive/*',
    },
    {
      view: 'archive',
      route: '/archive/*/*',
    },
    {
      view: 'roll',
      route: '/roll/*/*',
    },
    {
      view: 'box',
      route: '/box/*',
    },
    {
      view: 'contact',
      route: '/contact',
    },
    {
      view: 'info',
      route: '/info',
    },
    {
      view: 'sponsors',
      route: '/sponsors',
    },
    {
      view: 'login',
      route: '/login',
    },
    {
      view: 'news',
      route: '/news',
    },
    {
      view: 'press',
      route: '/press',
    },
    {
      view: 'licence',
      route: '/licence',
    },
  ]

  o.getView = function(){

    // if(location.pathname == '/press'){
    //   return 'press'
    // } else if(!o.store('earlyAccess')){
    //   return 'comingSoon'
    // }

    for (var i = 0; i < views.length; i++) {

      let v = views[i]

      if(minimatch(location.pathname, v.route)){
        return v.view
        break
      }

    }

    return 'splash'

  }

  window.addEventListener('popstate', function(e) {

    console.log('popstate')

    var state = e.state
    var view = null

    o.render(o)

  })

  done()

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/app/router.js